import securedAxios, { newSecuredAxios } from '../../../utils/secured-axios';
import { BookingPageTagName } from '../../../domain/entities/BookingPage';
import { MerchantBookingPrimaryImage } from '../../../interfaces/merchants/bookings';
import { buildApiV2Url } from 'src/utils/request-url';

export type VoucherAssignedBookingPage = {
  public_id: string;
  name: string;
  description_text?: string;
  tag_names: BookingPageTagName[];
  lowest_price?: number;
  primary_image?: MerchantBookingPrimaryImage;
};

export type MerchantVoucher = {
  public_id: string;
  name: string;
  assigned_booking_pages: VoucherAssignedBookingPage[];
};

// clientでは使われていないのでSSR用のみを用意
export const fetchCouponDetailForSSR = async ({
  session,
  token,
  requestId,
  merchantPublicId,
  couponPublicId,
}: {
  session: string;
  token: string;
  requestId: string;
  merchantPublicId: string;
  couponPublicId: string;
}) => {
  const client = newSecuredAxios({ session, token, requestId });
  try {
    const { data } = await client.get<MerchantVoucher>(
      buildApiV2Url(
        `/merchants/${merchantPublicId}/vouchers/${couponPublicId}`,
      ),
    );

    return data;
  } catch (error) {
    throw error;
  }
};

export const fetchMerchantCoupons = async (merchantPublicId: string) => {
  const { data } = await securedAxios.get<{
    vouchers: MerchantVoucher[];
  }>(buildApiV2Url(`/merchants/${merchantPublicId}/vouchers`));
  return data.vouchers;
};

export const fetchMerchantCouponsForSSR = async ({
  session,
  token,
  requestId,
  merchantPublicId,
}: {
  session: string;
  token: string;
  requestId: string;
  merchantPublicId: string;
}) => {
  const client = newSecuredAxios({ session, token, requestId });
  try {
    const { data } = await client.get<{
      vouchers: MerchantVoucher[];
    }>(buildApiV2Url(`/merchants/${merchantPublicId}/vouchers`));
    return data.vouchers;
  } catch (error) {
    throw error;
  }
};
